module.exports = __webpack_public_path__ + "static/media/coursebg2.11c45b3d.png";